(ns dashboard.views.settings.teams
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen vec-move vec-remove index-of cs]]
   [dashboard.events.spaces :as space-events]
   [dashboard.events.users :as user-events]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.select :refer [select space-select]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.profile :refer [profile-img display-user-fullname]]
   [dashboard.components.radiogroup :refer [color-circle color-group]]
   [dashboard.components.command-palletes :refer [user-command-palletes]]
   ["@heroicons/react/solid" :refer
    [LocationMarkerIcon XIcon ChevronUpIcon ChevronDownIcon]]
   ["date-fns" :refer [formatISO formatDistance]]))

(defn team-drawer-content [{:keys [state command-state]}]
  (let [team-members (->> (listen ::subs/space-staffs)
                          (filter #(= (:teamId %) (get-in @state [:team :id]))))
        member-ids (or (get-in @state [:team :memberIds]) [])
        sorted-team-members (sort-by #(or (index-of member-ids (:id %)) 1000) team-members)
        sorted-team-member-ids (mapv :id sorted-team-members)]
    [:div.relative.mt-6.flex-1.px-4.sm:px-6

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :team/name)]]
      [:div.sm:col-span-3
       [input
        {:auto-complete "name"
         :name "name"
         :type "text"
         :disabled? (= (:action @state) :view)
         :default-value (get-in @state [:team :name])
         :on-change #(swap! state assoc-in [:team :name] %)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        "Name JP"]]
      [:div.sm:col-span-3
       [input
        {:auto-complete "name"
         :name "name"
         :type "text"
         :disabled? (= (:action @state) :view)
         :default-value (get-in @state [:team :nameJp])
         :on-change #(swap! state assoc-in [:team :nameJp] %)}]]]

     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
      [:div
       [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :team/color)]]
      [:div.sm:col-span-3.w-full.flex
       [color-group
        {:class "flex"
         :selected (get-in @state [:team :color])
         :on-change #(swap! state assoc-in [:team :color] %)
         :size 4
         :colors (listen ::subs/colors)}]]]

     [:div.py-2.mt-3
      [:div.flex.justify-between.items-center
       [:label.block.text-sm.font-medium.text-gray-700
        (tr :team/members)
        (when (not (empty? team-members))
          [:span.ml-1
           (str "(" (count team-members) ")")])]
       [button
        {:disabled? (= (:action @state) :view)
         :small? true
         :on-click #(reset! command-state {:is-open? true})}
        (tr :action/add)]]
      [:div.-mx-4.mt-2.flex.flex-col.sm:-mx-6.md:mx-0.mb-4
       [:table.divide-y.divide-gray-300
        [:thead
         [:tr
          [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0
           {:class "py-2.5"
            :scope "col"}
           (tr :user/name)]
          [:th.pr-3.text-right.text-sm.font-semibold.text-gray-900
           {:class "py-2.5"
            :scope "col"}
           (tr :action/edit)]]]
        [:tbody
         (if (not (empty? team-members))
           (doall
            (for [[idx member] (->> sorted-team-members
                                    (map-indexed vector))
                  :let [member-uuid (:id member)]]
              ^{:key member-uuid}
              [:tr.divide-x
               [:td.py-1.px-2.font-semibold.text-sm.flex.items-center
                (display-user-fullname member)]
               [:td.whitespace-nowrap.py-1.pl-2.text-right.text-sm.font-medium.pr-3.space-x-1
                [:a
                 {:type "button"
                  :disabled (= idx 0)
                  :on-click #(swap! state assoc-in [:team :memberIds] (vec-move sorted-team-member-ids idx (- idx 1)))}
                 [:> ChevronUpIcon
                  {:aria-hidden true
                   :class (cs "h-4 w-4"
                              (if (= idx 0)
                                "text-gray-300"
                                "text-gray-600 hover:text-primary-900"))}]]
                [:a.text-gray-600
                 {:type "button"
                  :disabled (= idx (- (count team-members) 1))
                  :on-click #(swap! state assoc-in [:team :memberIds] (vec-move sorted-team-member-ids idx (+ idx 1)))}
                 [:> ChevronDownIcon
                  {:class (cs "h-4 w-4"
                              (if (= idx (- (count team-members) 1))
                                "text-gray-300"
                                "text-gray-600 hover:text-primary-900"))
                   :aria-hidden true}]]
                [:a.text-primary-600.hover:text-primary-900
                 {:type "button"
                  :on-click #(re-frame/dispatch
                              [::user-events/update-user {:user (assoc member :teamId nil)}])}
                 [:> XIcon
                  {:class "h-4 w-4"
                   :aria-hidden true}]]]]))
           [:tr.divide-x
            [:td.py-1.px-2.text-sm.flex.items-center
             {:scope "row"
              :colSpan 2}
             "No members"]])]
        [:tfoot
         [:tr
          [:th.hidden.pl-6.pr-3.pt-3.text-right.text-sm.font-normal.text-gray-500.sm:table-cell.md:pl-0
           {:scope "row"
            :colSpan 1}
           (tr :team/members)]

          [:td.pl-3.pr-4.pt-3.text-right.text-sm.text-gray-500.sm:pr-6
           (count sorted-team-members)]]]]]]

     [:div.flex.flex-shrink-0.justify-end.py-4
      [button
       {:on-click (fn []
                    (let [space (listen ::subs/selected-space)
                          teams (or (:teams space) [])
                          team (:team @state)
                          idx (index-of (map :id teams) (:id team))]
                      (do
                        (re-frame/dispatch
                         (case (:action @state)
                           :add [::space-events/update-space
                                 {:space (assoc space :teams (conj teams team))}]
                           :delete [::space-events/update-space
                                    {:space (assoc space :teams
                                                   (into [] (filter #(not= (:id team) (:id %)) teams)))}]
                           :edit [::space-events/update-space
                                  {:space (assoc-in space [:teams idx] team)}]
                           ""))
                        (reset! state {:is-open? false
                                       :team nil}))))}
       (case (:action @state)
         :add (tr :action/create)
         :delete (tr :action/delete)
         :edit (tr :action/save)
         "")]]]))

(defn content []
  (let [drawer-state (reagent/atom {:is-open? false
                                    :team nil
                                    :action nil})
        command-state (reagent/atom {:is-open? false})]
    (fn []
      (let [default-team {:id (str (random-uuid))
                          :name ""
                          :nameJp ""
                          :color "red"}]
        [:div
         [drawer
          {:state drawer-state
           :title (tr :action/add-fn (tr :user/team))
           :content [team-drawer-content
                     {:state drawer-state
                      :command-state command-state}]}]
         [user-command-palletes
          {:state command-state
           :default-filters {:space (listen ::subs/selected-space-id)}
           :on-click #(let [user (get (listen ::subs/staffs-by-id) %)]
                        (re-frame.core/dispatch
                         [::user-events/update-user {:user (assoc user :teamId (get-in @drawer-state [:team :id]))}]))}]
         [:div.px-4.pt-6
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto
            [space-select
             {:class "w-64"
              :selected (listen ::subs/selected-space)
              :on-change #(do
                            (re-frame/dispatch [::space-events/select-space {:id %}])
                            (re-frame/dispatch [:navigate :route.settings/teams
                                                {:space-id (str %)}]))}]]

           [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
            [button
             {:on-click #(reset! drawer-state {:is-open? true
                                               :team default-team
                                               :action :add})}
             (tr :action/add-fn (tr :user/team))]]]]
         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :team/color)
                        :key :color
                        :class "w-10"
                        :render-cell (fn [color]
                                       [:div.flex
                                        [color-circle
                                         {:color color
                                          :size 6}]])}
                       {:title (tr :team/name)
                        :key :name
                        :render-cell (fn [name row]
                                       [:div.flex.flex-col
                                        [:span.font-semibold
                                         name]
                                        [:span.text-gray-500
                                         (:nameJp row)]])}
                       {:title (tr :team/members)
                        :key :members
                        :render-cell (fn [name team]
                                       [:span
                                        (->> (listen ::subs/space-staffs)
                                             (filter #(= (:teamId %) (:id team)))
                                             (count))])}]
             :rows (listen ::subs/teams)
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click  #(reset! drawer-state {:is-open? true
                                                          :team %
                                                          :action :edit})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click  #(reset! drawer-state {:is-open? true
                                                          :team %
                                                          :action :delete})}]}]]]]))))
